import { ValueType } from "@/enums/ValueType";

export const factorTweedeInkomen = {
	metadata: {
		type: ValueType.Percentage,
	},
	values: {
		"2016-01-01": { value: 0.5 },
		"2017-01-01": { value: 0.6 },
		"2018-01-01": { value: 0.7 },
		"2020-01-01": {
			metadata: {
				reference:
					"https://www.nibud.nl/onderzoeksrapporten/adviesrapport-financieringslastnormen-2020/",
			},
			value: 0.8,
		},
		"2021-01-01": {
			metadata: {
				reference:
					"https://www.nibud.nl/onderzoeksrapporten/rapport-advies-financieringslastnormen-2021/",
			},
			value: 0.9,
		},
		"2023-01-01": {
			metadata: {
				reference:
					"https://www.nibud.nl/onderzoeksrapporten/rapport-advies-financieringslastnormen-2023-2022/",
			},
			value: 1.0,
		},
	},
};
